import catalog from './catalog';
import approval from './approval';
import assignCatalog from './assignCatalog';

export default {
    catalog ,
    approval ,
    assignCatalog
}